/**
 * useBackToState
 */
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { useDictionary } from 'bdvp-common/src/hooks/config';

const useBackToState = (labelKey) => {

    const location = useLocation();
    const dictionary = useDictionary();

    const backToState = useMemo(() => ({
        backToButton: {
            label: dictionary[labelKey] || 'Back',
            url: {
                pathname: location.pathname,
                search: location.search,
            },
        },
    }), [
        labelKey,
        dictionary,
        location,
    ]);

    return backToState;

};

export default useBackToState;
